import { render } from "./DicomParser.vue?vue&type=template&id=34931cff"
import script from "./DicomParser.vue?vue&type=script&lang=js"
export * from "./DicomParser.vue?vue&type=script&lang=js"

import "./DicomParser.vue?vue&type=style&index=0&id=34931cff&lang=css"

import exportComponent from "/var/www/html2/esmanage/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__